<template>
  <!-- Apps this user's role may open with their dilatih.co login (SsoController, config/sso.php). -->
  <div v-if="apps.length" class="sso-apps">
    <div class="sso-apps-title">Aplikasi</div>
    <button
      v-for="item in apps"
      :key="item.app + item.to"
      class="side-link text-decoration-none"
      :disabled="opening"
      @click="open(item)"
    >
      <span class="icon-dash"
        ><img
          :src="require('@/assets/images/cms/' + icon(item.app))"
          alt=""
          srcset="" /></span
      >{{ item.label }}
    </button>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { useToast } from 'vue-toastification'
import Api from '@/api/Api'

const ICONS = { erp: 'income.png', chatwoot: 'Notif.png', n8n: 'Setting.png', waha: 'Computer.png' }

export default {
  name: 'SsoApps',
  setup() {
    const toast = useToast()
    const apps = ref([])
    const opening = ref(false)
    const auth = () => ({ Authorization: `Bearer ${window.localStorage.getItem('token')}` })

    onMounted(async () => {
      try {
        const { data } = await Api.get('/admin/sso', { headers: auth() })
        apps.value = Array.isArray(data?.apps) ? data.apps : []
      } catch (e) {
        apps.value = []
      }
    })

    // The backend hands out a one-minute, single-use link. The tab is opened before the
    // request, while we still have the click, so popup blockers let it through.
    async function open(item) {
      if (opening.value) return
      opening.value = true
      const tab = window.open('', '_blank')
      if (tab) tab.opener = null
      try {
        const { data } = await Api.get(`/admin/sso/${item.app}`, {
          params: item.to ? { to: item.to } : {},
          headers: auth(),
        })
        if (!data?.url) throw new Error(data?.message || data?.status || 'no url')
        if (tab) tab.location.href = data.url
        else window.location.href = data.url
      } catch (e) {
        if (tab) tab.close()
        toast.error(e?.response?.data?.message || `Gagal membuka ${item.label}, coba lagi.`)
      } finally {
        opening.value = false
      }
    }

    return { apps, opening, open, icon: (app) => ICONS[app] || 'cms.svg' }
  },
}
</script>

<style scoped>
.sso-apps-title {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: var(--neutral6, #8a8fa3);
  padding: 12px 16px 0;
}
.sso-apps .side-link {
  background: none;
}
</style>
